// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ing-datepicker {\n    position: absolute;\n    width: 480px;\n    margin: auto;\n    font-size: 15px;\n    color: var(--color-text);\n    background: #fff;\n    border: 1px solid #e6e6e6;\n    padding: 10px;\n    top: calc(100% + 10px);\n    left: 0;\n}\n\n.bloc_date_calendrier_double {\n    position: relative;\n}\n\n@media (max-width: 480px) {\n    .ing-datepicker {\n        width: 240px;\n    }\n}", ""]);
// Exports
module.exports = exports;
